// extracted by mini-css-extract-plugin
module.exports = {"media":"ReadCatalogNFCTag_media__ck7_m","card":"ReadCatalogNFCTag_card__2cop0","headerSearch":"ReadCatalogNFCTag_headerSearch__mJ7Ag"};